module.exports = __webpack_public_path__ + "static/media/sponsorship.a19c9af3.jpg";